<gms-checkbox
  [id]="data?.id"
  [control]="data?.control"
  (checkboxFocused)="checkboxFocused()"
>
</gms-checkbox>
